export namespace CustomLibary {
  export class Event<T> {
    private _handlers: Array<Function>;
    constructor() {
      this._handlers = [];
    }
    Subscribe(handler: (args: T) => void) {
      if (handler) {
        this._handlers.push(handler);
      }
    }
    UnSubscribe() {
      //TODO:
      this._handlers = [];
    }
    Fire(data: T) {
      if (this._handlers) {
        this._handlers.forEach((handler) => {
          handler(data);
        });
      }
    }
  }
}
